import {
  FETCH_DRIVERS_EARNING,
  FETCH_DRIVERS__EARNING_SUCCESS,
  FETCH_DRIVERS__EARNING_FAILED,
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';
import store from '../store/store';

export const fetchDriverEarnings = () => async (dispatch) => {
  dispatch({
    type: FETCH_DRIVERS_EARNING,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from('routes').select('*').in('status', ['PAID', 'COMPLETE']);
      if (userInfo?.tenant_id) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      if (userInfo?.usertype === 'driver') {
        query = query.eq('driver_id', userInfo.uid);
      }

      const { data, error } = await query;
      if (!error && data) {
        const monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const renderobj = {};

        data.forEach(r => {
          const bdt = new Date(r.created_at || Date.now());
          const driverId = r.driver_id || 'unknown';
          const uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth() + '_' + driverId;
          const distKm = Number(r.total_distance_km || 10);
          const share = distKm * 2;

          if (renderobj[uniqueKey]) {
            renderobj[uniqueKey].driverShare = (parseFloat(renderobj[uniqueKey].driverShare) + share).toFixed(2);
            renderobj[uniqueKey].total_rides += 1;
          } else {
            renderobj[uniqueKey] = {
              dated: r.created_at,
              year: bdt.getFullYear(),
              month: bdt.getMonth(),
              monthsName: monthsName[bdt.getMonth()],
              driverName: r.driver_name || 'Motorista',
              driverShare: share.toFixed(2),
              driverVehicleNo: r.vehicle_id || '',
              driverUId: driverId,
              uniqueKey: uniqueKey,
              total_rides: 1
            };
          }
        });

        dispatch({
          type: FETCH_DRIVERS__EARNING_SUCCESS,
          payload: Object.values(renderobj)
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_DRIVERS__EARNING_SUCCESS,
    payload: []
  });
};
